import { render, staticRenderFns } from "./device_dtl.vue?vue&type=template&id=f1ce1728&scoped=true&"
import script from "./device_dtl.vue?vue&type=script&lang=js&"
export * from "./device_dtl.vue?vue&type=script&lang=js&"
import style0 from "./device_dtl.vue?vue&type=style&index=0&id=f1ce1728&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ce1728",
  null
  
)

export default component.exports